import { IntegrationStepSchema } from '@feedyou-ai/feedbot-schema'

import { Search } from '../../../types'
import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<IntegrationStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      storage: [
        'storage',
        'outputs.%key%.storage',
        'storages.%key%.storage',
        'attachments.%key%.storage'
      ],
      text: [
        'condition',
        'outputs.%key%.storage',
        'storages.%key%.storage',
        'attachments.%key%.storage'
      ]
    })
  )
}
